import { BsChatDots } from "react-icons/bs";
import { FaRegUser } from "react-icons/fa";
import { IoMdNotificationsOutline } from "react-icons/io";
import { Link } from "react-router-dom";
import Container from "./Container";

const Header = () => {
  return (
    <div>
      <Container>
        <div className="flex items-center justify-between  ">
          <div className="w-[25%]">
            <Link to="/">
              <img
                className="ml-[-25px]"
                src="/assets/images/logo.png"
                alt="logo"
              />
            </Link>
          </div>
          <div className="w-[75%]">
            <div className="flex items-center justify-end gap-x-14">
              <div className="flex items-center gap-x-6">
                <span className="relative inline-block">
                  <BsChatDots className="h-8 w-8 cursor-pointer text-userIcon drop-shadow-lg" />

                  <span className="absolute top-1 right-1.5 inline-block h-2 w-2 translate-x-1/2 -translate-y-1/2 transform rounded-full bg-red-600"></span>
                </span>

                <span className="relative inline-block">
                  <IoMdNotificationsOutline className="h-10 w-10 cursor-pointer text-userIcon drop-shadow-lg" />
                  <span className="absolute top-2.5 right-3 inline-block h-2 w-2 translate-x-1/2 -translate-y-1/2 transform rounded-full bg-red-600"></span>
                </span>
                <Link to="/user">
                  <FaRegUser className="h-8 w-8 cursor-pointer text-userIcon drop-shadow-lg" />
                </Link>
              </div>
            </div>
            <div className="mt-6 flex items-center justify-end gap-x-3.5">
              <h3 className="font-regular font-pop text-xl drop-shadow-lg ">
                Welcome,{" "}
                <span className="font-semibold text-[#1D9BF0] ">Guest</span>
              </h3>
              <div className="flex gap-x-2.5">
                <Link to="/login">
                  <button className="rounded-[8px] border border-solid border-gray bg-primary px-6 py-2.5 font-pop text-base font-medium text-white drop-shadow-lg">
                    Log in
                  </button>
                </Link>
                <Link to="/register">
                  <button className="rounded-[8px] border border-solid border-gray bg-primary px-4 py-2.5 font-pop text-base font-medium text-white drop-shadow-lg">
                    Register
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Container>
    </div>
  );
};

export default Header;
